import React from 'react'
import useSWR from "swr";
import LanguageApi from "../components/Language";
const DownCat = (props) => {
  const {download_catalog} = LanguageApi();
    const { data, error } = useSWR(
        process.env.REACT_APP_DEF_URL + "catalog.php?link=" + props.link
      );
      if (error) return <div>failed to load</div>
      if (!data) return <div>loading...</div>
  return (
    <a href={`${data.catalog_link}`} target="_blank" rel="noreferrer">{download_catalog}</a>
  )
}

export default DownCat